import { Injectable } from "@angular/core";
import { RemoteRepositoryInterface } from "../../remote/remote.interface";
import { LogRepositoryInterface } from "./log.interface";
import { Observable } from "rxjs";
import { EventType } from "../../../crossconcern/types/event.type";
import { LogList } from "../../entities/loglist.model";
import { map } from "rxjs/operators";

@Injectable()
export class LogRepository implements LogRepositoryInterface {

    constructor(private remoteRepository: RemoteRepositoryInterface) {}

    public addEvent(event: EventType): Observable<{}> {
        return this.remoteRepository.postWithoutErrors("logs", event);
    }

    public getLogs(size: number, page: number): Observable<LogList> {
        let url = "logs";
        url += "?size=" + size;
        url += "&page=" + page;
        return this.remoteRepository.get(url)
            .pipe(
                map((value) => new LogList(value as JSON))
            );
    }
}
